export const SITE = {
  name: "UnfallExpert24",
  domain: "https://www.unfallexpert24.de",
  phone: "0221 67029067",
  phoneHref: "tel:+4922167029067",
  phoneKrefeld: "02151 4793290",
  phoneKrefeldHref: "tel:+4921514793290",
  whatsapp: process.env.REACT_APP_WHATSAPP_NUMBER || "491779807733",
  whatsappText: "Hallo UnfallExpert24, ich hatte einen Unfall und benötige ein Gutachten.",
  email: "info@unfallexpert24.de",
  addressKoeln: "Vogelsanger Straße 11, 50823 Köln",
  addressKrefeld: "Oberbruchstraße 142, 47807 Krefeld",
  facebook: "https://www.facebook.com/UnfallExpert24",
  instagram: "https://www.instagram.com/unfallexpert24",
  youtube: "https://www.youtube.com/@UnfallExpert24",
  linkedin: "https://www.linkedin.com/company/unfallexpert24",
  tiktok: "https://www.tiktok.com/@unfallexpert24",
};

// Zentrale, einheitliche Versprechen – an genau dieser Stelle ändern,
// überall auf der Website wirksam. Keine widersprüchlichen Zeitangaben mehr.
export const PROMISES = {
  erreichbarkeit: "Mo–Fr 9–22 Uhr erreichbar, Sa & So nach Vereinbarung",
  rueckruf: "Rückruf in der Regel innerhalb von 15 Minuten (Mo–Fr 9–22 Uhr)",
  rueckrufKurz: "Antwort in ~15 Min.",
  termin: "Termin oft noch am selben Tag",
  lieferzeit: "Gutachten in der Regel innerhalb von 24 Stunden",
  lieferzeitKurz: "Gutachten in 24 h",
};

export const SERVICE_LINKS = [
  { slug: "unfallgutachten", title: "Unfallgutachten" },
  { slug: "kfz-gutachten", title: "KFZ-Gutachten" },
  { slug: "haftpflichtgutachten", title: "Haftpflichtgutachten" },
  { slug: "kasko-gutachten", title: "Kasko-Gutachten" },
  { slug: "teilkasko-gutachten", title: "Teilkasko-Gutachten" },
  { slug: "vollkasko-gutachten", title: "Vollkasko-Gutachten" },
  { slug: "gutachterliche-stellungnahme", title: "Gutachterliche Stellungnahme" },
  { slug: "kurzgutachten", title: "Kurzgutachten" },
  { slug: "beweissicherungsgutachten", title: "Beweissicherungsgutachten" },
  { slug: "lkw-gutachten", title: "LKW-Gutachten" },
  { slug: "kostenvoranschlag", title: "Kostenvoranschlag" },
  { slug: "kfz-wertgutachten", title: "KFZ-Wertgutachten" },
  { slug: "oldtimer-gutachten", title: "Oldtimer-Gutachten" },
  { slug: "gebrauchtwagenbewertung", title: "Gebrauchtwagenbewertung" },
  { slug: "restwertgutachten", title: "Restwertgutachten" },
  { slug: "leasingrueckgabe-gutachten", title: "Leasingrückgabe-Gutachten" },
  { slug: "fuhrpark-schadenmanagement", title: "Fuhrpark-Schadenmanagement" },
  { slug: "motorrad-gutachten", title: "Motorrad-Gutachten" },
  { slug: "wohnmobil-gutachten", title: "Wohnmobil-Gutachten" },
  { slug: "e-auto-gutachten", title: "E-Auto-Gutachten" },
  { slug: "hagelschaden-gutachten", title: "Hagelschaden-Gutachten" },
  { slug: "reparaturbestaetigung", title: "Reparaturbestätigung" },
  { slug: "nutzungsausfallbestaetigung", title: "Nutzungsausfallbestätigung" },
  { slug: "reparaturrechnungspruefung", title: "Reparaturrechnungsprüfung" },
  { slug: "lackschichtdickenmessung", title: "Lackschichtdickenmessung" },
  { slug: "achsvermessung-rahmenvermessung", title: "Achs- & Rahmenvermessung" },
  { slug: "technische-beratung", title: "Technische Beratung" },
];

export const CITY_LINKS = [
  { slug: "koeln", name: "Köln" },
  { slug: "krefeld", name: "Krefeld" },
  { slug: "duesseldorf", name: "Düsseldorf" },
  { slug: "bergheim", name: "Bergheim" },
  { slug: "dortmund", name: "Dortmund" },
  { slug: "luedenscheid", name: "Lüdenscheid" },
  { slug: "hagen", name: "Hagen" },
  { slug: "moenchengladbach", name: "Mönchengladbach" },
  { slug: "aachen", name: "Aachen" },
  { slug: "bonn", name: "Bonn" },
  { slug: "overath", name: "Overath" },
  { slug: "moers", name: "Moers" },
  { slug: "duisburg", name: "Duisburg" },
  { slug: "essen", name: "Essen" },
  { slug: "leverkusen", name: "Leverkusen" },
  { slug: "bergisch-gladbach", name: "Bergisch Gladbach" },
  { slug: "pulheim", name: "Pulheim" },
  { slug: "frechen", name: "Frechen" },
  { slug: "huerth", name: "Hürth" },
  { slug: "bruehl", name: "Brühl" },
  { slug: "kerpen", name: "Kerpen" },
  { slug: "hamburg", name: "Hamburg" },
  { slug: "berlin", name: "Berlin" },
  { slug: "muenchen", name: "München" },
  { slug: "stuttgart", name: "Stuttgart" },
  { slug: "dresden", name: "Dresden" },
  { slug: "frankfurt", name: "Frankfurt am Main" },
  { slug: "bremen", name: "Bremen" },
  { slug: "heidelberg", name: "Heidelberg" },
];

export const ARTICLE_CATEGORIES = [
  { slug: "unfallgutachten", name: "Unfallgutachten" },
  { slug: "kfz-gutachten-kosten", name: "Kfz-Gutachten & Kosten" },
  { slug: "versicherung-schadensregulierung", name: "Versicherung & Schadensregulierung" },
  { slug: "recht-gesetz", name: "Recht & Gesetz" },
  { slug: "wertgutachten-gebrauchtwagen", name: "Wertgutachten & Gebrauchtwagen" },
  { slug: "news", name: "News für Autofahrer" },
];

export const ARTICLE_IMAGES = {
  hero: "https://images.unsplash.com/photo-1597328290883-50c5787b7c7e?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzNDR8MHwxfHNlYXJjaHwxfHxjYXIlMjBkYW1hZ2UlMjBpbnNwZWN0aW9uJTIwYXBwcmFpc2VyJTIwdmVoaWNsZSUyMGFjY2lkZW50fGVufDB8fHx8MTc5MjY4NjE4OHww&ixlib=rb-4.1.0&q=85",
  tablet: "https://images.pexels.com/photos/6870326/pexels-photo-6870326.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  inspection: "https://images.pexels.com/photos/6870317/pexels-photo-6870317.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  cologne: "https://images.pexels.com/photos/20314797/pexels-photo-20314797.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  damaged: "https://images.unsplash.com/photo-1684413770726-4ce2b66c3ab0?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzNDR8MHwxfHNlYXJjaHw0fHxjYXIlMjBkYW1hZ2UlMjBpbnNwZWN0aW9uJTIwYXBwcmFpc2VyJTIwdmVoaWNsZSUyMGFjY2lkZW50fGVufDB8fHx8MTc5MjY4NjE4OHww&ixlib=rb-4.1.0&q=85",
  towtruck: "https://images.unsplash.com/photo-1673187139211-1e7ec3dd60ec?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzNDR8MHwxfHNlYXJjaHwyfHxjYXIlMjBkYW1hZ2UlMjBpbnNwZWN0aW9uJTIwYXBwcmFpc2VyJTIwdmVoaWNsZSUyMGFjY2lkZW50fGVufDB8fHx8MTc5MjY4NjE4OHww&ixlib=rb-4.1.0&q=85",
  art_unfall_checkliste: "https://images.pexels.com/photos/5403208/pexels-photo-5403208.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  art_gutachten_kosten: "https://images.pexels.com/photos/16827970/pexels-photo-16827970.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  art_kostenvoranschlag: "https://images.pexels.com/photos/19200993/pexels-photo-19200993.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  art_wertminderung: "https://images.pexels.com/photos/36729855/pexels-photo-36729855.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  art_totalschaden: "https://images.unsplash.com/photo-1686966933735-305bd8fe0a77?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2Njl8MHwxfHNlYXJjaHw0fHxkYW1hZ2VkJTIwY2FyJTIwdG93JTIwdHJ1Y2slMjBjcmFzaGVkJTIwdmVoaWNsZXxlbnwwfHx8fDE3OTI2OTAzMzJ8MA&ixlib=rb-4.1.0&q=85",
  art_mietwagen: "https://images.pexels.com/photos/8482859/pexels-photo-8482859.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  art_parkschaden: "https://images.unsplash.com/photo-1611760399750-bf3b95ac8f0a?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NDh8MHwxfHNlYXJjaHwyfHxjYXIlMjBkb29yJTIwc2NyYXRjaCUyMHBhcmtpbmclMjBnYXJhZ2V8ZW58MHx8fHwxNzkyNjkwMzMyfDA&ixlib=rb-4.1.0&q=85",
  art_versicherung_streit: "https://images.pexels.com/photos/7731333/pexels-photo-7731333.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  art_firmenwagen: "https://images.unsplash.com/photo-1616804947838-6646ae0e423d?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2Mzl8MHwxfHNlYXJjaHwxfHxidXNpbmVzc21hbiUyMGNvbXBhbnklMjBmbGVldCUyMGNhcnxlbnwwfHx8fDE3OTI2OTAzMzJ8MA&ixlib=rb-4.1.0&q=85",
  art_eauto: "https://images.unsplash.com/photo-1593941707882-a5bba14938c7?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzF8MHwxfHNlYXJjaHwyfHxlbGVjdHJpYyUyMGNhciUyMGNoYXJnaW5nJTIwRVYlMjBzdGF0aW9ufGVufDB8fHwxNzkyNjkwMzMyfDA&ixlib=rb-4.1.0&q=85",
  art_waschanlage: "https://images.pexels.com/photos/210627/pexels-photo-210627.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  art_kasko: "https://images.pexels.com/photos/5351114/pexels-photo-5351114.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  art_dashcam: "https://images.unsplash.com/photo-1765959106936-851735565c12?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2MTJ8MHwxfHNlYXJjaHw0fHxkYXNoY2FtJTIwY2FyJTIwd2luZHNoaWVsZCUyMG1vdW50ZWQlMjBpbnNpZGV8ZW58MHx8fHwxNzkyNjkxMTYwfDA&ixlib=rb-4.1.0&q=85",
  art_winter: "https://images.unsplash.com/photo-1610635974060-9284319ceac9?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NDh8MHwxfHNlYXJjaHwxfHxjYXIlMjBkcml2aW5nJTIwc25vd3klMjB3aW50ZXIlMjByb2FkfGVufDB8fHx8MTc5MjY5MTE2MHww&ixlib=rb-4.1.0&q=85",
  art_werkstatt: "https://images.unsplash.com/photo-1615906655593-ad0386982a0f?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMjh8MHwxfHNlYXJjaHw0fHxjYXIlMjBtZWNoYW5pYyUyMHdvcmtzaG9wJTIwcmVwYWlyJTIwc2hvcHxlbnwwfHx8fDE3OTI2OTExNjB8MA&ixlib=rb-4.1.0&q=85",
  art_kreisverkehr: "https://images.pexels.com/photos/7691757/pexels-photo-7691757.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  art_gebrauchtwagen: "https://images.unsplash.com/photo-1625047509248-ec889cbff17f?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Nzd8MHwxfHNlYXJjaHwxfHxpbnNwZWN0aW5nJTIwdXNlZCUyMGNhciUyMGVuZ2luZSUyMGhvb2QlMjBidXlpbmd8ZW58MHx8fDE3OTI2OTExNjB8MA&ixlib=rb-4.1.0&q=85",
  art_kind_unfall: "https://images.pexels.com/photos/7708639/pexels-photo-7708639.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
};

export const PORTRAITS = {
  denis: "/team/denis.webp",
  giovanni: "/team/giovanni.webp",
  sezgin: "/team/sezgin.webp",
};

export const IMAGES = {
  hero: "https://images.unsplash.com/photo-1597328290883-50c5787b7c7e?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzNDR8MHwxfHNlYXJjaHwxfHxjYXIlMjBkYW1hZ2UlMjBpbnNwZWN0aW9uJTIwYXBwcmFpc2VyJTIwdmVoaWNsZSUyMGFjY2lkZW50fGVufDB8fHx8MTc5MjY4NjE4OHww&ixlib=rb-4.1.0&q=85",
  appraiserTablet: "https://images.pexels.com/photos/6870326/pexels-photo-6870326.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  appraiserInspection: "https://images.pexels.com/photos/6870317/pexels-photo-6870317.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  cologne: "https://images.pexels.com/photos/20314797/pexels-photo-20314797.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  damagedSide: "https://images.unsplash.com/photo-1684413770726-4ce2b66c3ab0?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzNDR8MHwxfHNlYXJjaHw0fHxjYXIlMjBkYW1hZ2UlMjBpbnNwZWN0aW9uJTIwYXBwcmFpc2VyJTIwdmVoaWNsZSUyMGFjY2lkZW50fGVufDB8fHx8MTc5MjY4NjE4OHww&ixlib=rb-4.1.0&q=85",
  towTruck: "https://images.unsplash.com/photo-1673187139211-1e7ec3dd60ec?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzNDR8MHwxfHNlYXJjaHwyfHxjYXIlMjBkYW1hZ2UlMjBpbnNwZWN0aW9uJTIwYXBwcmFpc2VyJTIwdmVoaWNsZSUyMGFjY2lkZW50fGVufDB8fHx8MTc5MjY4NjE4OHww&ixlib=rb-4.1.0&q=85",
};
